export default __webpack_public_path__ + "static/media/ic_arrow_prev.01275d45.svg";